import { client, client2 } from "../../../api/client";
import {QueryDispatcher, Result, QueryDispatcherAbort} from "../domain/QueryDispatcher"

export class APIQueryDispatcher implements QueryDispatcher{
  dispatch(query,args): Promise<{[key: string]: string} > {
    let p = new Promise<{[key: string]: string}>(function(resolve, reject){
      client
      .post(`query/`,{query,args})
      .then((response) => resolve(response.data))
      .catch(e => reject(e));
    })
    
    return p
  }
}

export class APIQueryDispatcherGET implements QueryDispatcher{
  dispatch(query,args): Promise<{[key: string]: string} > {
    if(args['args'] || args['force_get']){
      let params = {query:query}
      params['args']=args['args']
      if(args['ordering']){
        params['ordering'] = args['ordering']
      }
      if(args['limit']){
        params['limit'] = args['limit']
      }
      if(args['offset']){
        params['offset'] = args['offset']
      }
      let p = new Promise<{[key: string]: string}>(function(resolve, reject){
        client
        .get(`query/`,{params:params})
        .then((response) => resolve(response.data))
        .catch(e => reject(e));
      })
      
      return p
    }
    else{
      return new APIQueryDispatcher().dispatch(query,args)
    }
    
  }
}

export class APIQueryDispatcherAbort implements QueryDispatcherAbort {
  
  async dispatch(query, args) {
    const controller = new AbortController();
    let p = await new Promise<{[key: string]: string}>(function(resolve, reject){
      if (controller.signal.aborted) {
        console.log(controller.signal)
        reject(controller.signal.reason);
      }
      controller.signal.addEventListener("abort", () => {
        reject(controller.signal.reason);
      });
      client
      .post(`query/`,{query,args,signal:controller.signal})
      .then((response) => resolve(response.data))
      .catch(e => {
        reject(e);
      });
    })
    const res = new Result(p, controller)
    return res
  }
}

export class APIQueryDispatcher2 implements QueryDispatcher{
  dispatch(query,args): Promise<{[key: string]: string} > {
    let p = new Promise<{[key: string]: string}>(function(resolve, reject){
      client2
      .post(`query/`,{query,args})
      .then((response) => resolve(response.data))
      .catch(e => reject(e));
    })
    
    return p
  }
}

export class APIQueryDispatcherGET2 implements QueryDispatcher{
  dispatch(query,args): Promise<{[key: string]: string} > {
    if(args['args'] || args['force_get']){
      let params = {query:query}
      params['args']=args['args']
      if(args['ordering']){
        params['ordering'] = args['ordering']
      }
      if(args['limit']){
        params['limit'] = args['limit']
      }
      if(args['offset']){
        params['offset'] = args['offset']
      }
      let p = new Promise<{[key: string]: string}>(function(resolve, reject){
        client2
        .get(`query/`,{params:params})
        .then((response) => resolve(response.data))
        .catch(e => reject(e));
      })
      
      return p
    }
    else{
      return new APIQueryDispatcher2().dispatch(query,args)
    }
    
  }
}